import { InlineSupplierAi } from "@/components/renata/InlineSupplierAi";
import { createFileRoute } from "@tanstack/react-router";
import { CrudShellHeader } from "@/components/ds";
import { ClinicalPageShell } from "@/components/clinical";
import { SuppliersSection } from "@/components/operaciones/operaciones-sections";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";

export const Route = createFileRoute("/app/operaciones/proveedores")({
  component: OperacionesProveedoresPage,
  head: () => ({ meta: [{ title: "Proveedores — Operaciones" }] }),
});

function OperacionesProveedoresPage() {
  const tid = useWorkspaceTenantId();

  return (
    <div>
      <div className="mb-3"><InlineSupplierAi entity="proveedor" /></div>
        <CrudShellHeader title="Proveedores" backHref="/app/operaciones" backLabel="Volver a Abastecimiento" />
      <ClinicalPageShell offset="none" className="pt-6">
        {tid ? <SuppliersSection tid={tid} /> : null}
      </ClinicalPageShell>
    </div>
  );
}
